<div class="alert alert-warning" role="alert" *ngIf="!canDo('Servicios Unificados','Ver')">
    No tienes permisos para acceder al módulo de Servicios Unificados.
  </div>
<div class="row" *ngIf="canDo('Servicios Unificados','Ver')">
    <div class="col-sm-12 col-md-6 col-lg-8 col-xxxl-6">
        <div class="row">
            <div class="col-sm-12 col-lg-4 mb-4">
                <div class="card card-border-shadow-primary card-count pending">
                    <div class="card-body">
                        <div class="d-flex align-items-center">
                            <h5 class="ms-1 mb-0 me-2 count-pending">{{conut[0].pending == null ? 0 : conut[0].pending}}</h5>
                            <div class="avatar me-2">
                                <span class="avatar-initial rounded bg-label-primary">
                                    <img src="../../../../assets/img/icons/clock.svg" alt="" class="p-1">
                                </span>
                            </div>
                            <h5 class="text_pending mb-0">Pendientes</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-lg-4 mb-4">
                <div class="card card-border-shadow-warning card-count in_route">
                    <div class="card-body">
                        <div class="d-flex align-items-center">
                            <h5 class="ms-1 mb-0 me-2 count-in_route">{{conut[0].in_route == null ? 0 : conut[0].in_route}}</h5>
                            <div class="avatar me-2">
                                <span class="avatar-initial rounded bg-label-warning">
                                    <img src="../../../../assets/img/icons/truck.svg" alt="" class="p-1">
                                </span>
                            </div>
                            <h5 class="text_in_route mb-0">En Proceso</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-4 mb-4">
                <div class="card card-border-shadow-danger card-count good">
                    <div class="card-body">
                        <div class="d-flex align-items-center">
                            <h5 class="ms-1 mb-0 me-2 count-good">{{conut[0].good == null ? 0 : conut[0].good}}</h5>
                            <div class="avatar me-2">
                                <span class="avatar-initial rounded bg-label-danger">
                                    <img src="../../../../assets/img/icons/checkmark-circle.svg" alt="" class="p-1">
                                </span>
                            </div>
                            <h5 class="text_good mb-0">Finalizados</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="col-xl" *ngIf="canDo('Servicios Unificados','Ver')">
    <div class="card">
        <div class="card-header" *ngIf="dataUser.type_admin != 5">
            <div class="row">
                <div class="col-lg-12" [@fade]="isVisible ? 'visible' : 'hidden'">
                    <div class="row">
                        <div class="col-lg">
                            <label class="form-label text-base" for="folio">Folio</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="folio" placeholder="Buscar por folio"
                                    [(ngModel)]="formModel.folio" (ngModelChange)="onFolioInput()" autocomplete="off">
                            </div>
                        </div>
                        <div class="col-lg">
                            <label class="form-label text-base" for="basic-default-company">Cliente</label>
                            <div class="input-group input-group-merge">
                                <select name="" id="" class="form-select" [(ngModel)]="formModel.client"
                                    (change)="onSelectClient()">
                                    <option value="">Seleccionar</option>
                                    <option *ngFor="let item of dataClient" [value]="item.id">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg">
                            <label class="form-label text-base" for="basic-default-company">Estado</label>
                            <div class="input-group input-group-merge">
                                <select name="" id="" class="form-select" [(ngModel)]="formModel.status"
                                    (change)="onSelectStatus()">
                                    <option value="">Seleccionar</option>
                                    <option *ngFor="let item of data_combo" [value]="item.id">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg">
                            <label class="form-label text-base" for="basic-default-company">Fecha carga</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="upload_date"
                                    [(ngModel)]="formModel.upload_date" autocomplete="off">
                                <span class="input-group-text" (click)="removeDate('upload_date')">
                                    <i [ngClass]="formModel.upload_date ? 'ti ti-x' : 'ti ti-calendar'"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col-lg">
                            <label class="form-label text-base" for="basic-default-company">Fecha descarga</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="download_date"
                                    [(ngModel)]="formModel.download_date" autocomplete="off">
                                <span class="input-group-text" (click)="removeDate('download_date')">
                                    <i [ngClass]="formModel.download_date ? 'ti ti-x' : 'ti ti-calendar'"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- <div class="col-lg-2 float-right">
                    <br>

                    <a class="btn btn-info btn-service" (click)="refreshGrid()">
                        <i class="ti ti-refresh"></i>
                    </a>
                    <a class="btn btn-info btn-service" routerLink="/service/add"
                        *ngIf="dataUser.type_admin == 1 || dataUser.type_admin == 2 || dataUser.type_admin == 3">
                        <i class="ti ti-plus"></i>
                    </a>
                </div> -->
            </div>
        </div>
        <div class="card-body">
            <div class="tab-service-bar mb-2">
                <button class="tab-service-btn" [class.active]="activeTab === 'unique'" (click)="switchTab('unique')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="7" r="4" stroke="#00A0E1" stroke-width="1.5"/>
                        <path d="M12 11L12 18" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M17 19C17 20.1046 14.7614 21 12 21C9.23858 21 7 20.1046 7 19" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                    Servicios de viáticos únicos
                </button>
                <button class="tab-service-btn" [class.active]="activeTab === 'shared'" (click)="switchTab('shared')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20.5 5.5C20.5 7.15685 19.1569 8.5 17.5 8.5C15.8431 8.5 14.5 7.15685 14.5 5.5C14.5 3.84315 15.8431 2.5 17.5 2.5C19.1569 2.5 20.5 3.84315 20.5 5.5Z" stroke="#141B34" stroke-width="1.5"/>
                        <path d="M8.5 11.5C8.5 13.1569 7.15685 14.5 5.5 14.5C3.84315 14.5 2.5 13.1569 2.5 11.5C2.5 9.84315 3.84315 8.5 5.5 8.5C7.15685 8.5 8.5 9.84315 8.5 11.5Z" stroke="#141B34" stroke-width="1.5"/>
                        <path d="M21.5 18.5C21.5 20.1569 20.1569 21.5 18.5 21.5C16.8431 21.5 15.5 20.1569 15.5 18.5C15.5 16.8431 16.8431 15.5 18.5 15.5C20.1569 15.5 21.5 16.8431 21.5 18.5Z" stroke="#141B34" stroke-width="1.5"/>
                        <path d="M14.5348 4.58109C14.1554 4.52765 13.7677 4.5 13.3733 4.5C10.2974 4.5 7.62058 6.18227 6.24054 8.66317M19.7131 7.49453C20.8311 8.86497 21.5 10.6056 21.5 12.5C21.5 13.8758 21.1472 15.1705 20.5258 16.3012M15.8816 20.1117C15.0917 20.3638 14.2486 20.5 13.3733 20.5C9.58287 20.5 6.39853 17.9454 5.5 14.4898" stroke="#141B34" stroke-width="1.5"/>
                    </svg>
                    Servicios con viáticos compartidos
                </button>
            </div>
            <!-- Grid: viáticos únicos -->
            <ag-grid-angular
                *ngIf="activeTab === 'unique'"
                style="width: 100%; height: 60vh;"
                class="ag-theme-alpine"
                [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef"
                (cellClicked)="onCellClicked($event)"
                (gridReady)="onGridReady($event)">
            </ag-grid-angular>

            <!-- Grid: viáticos compartidos -->
            <ng-container *ngIf="activeTab === 'shared'">
                <div *ngIf="sharedGroupsLoading" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status"></div>
                </div>
                <div *ngIf="!sharedGroupsLoading && sharedGroups.length === 0" class="text-center text-muted py-5">
                    No hay servicios con viáticos compartidos.
                </div>
                <ag-grid-angular
                    *ngIf="!sharedGroupsLoading && sharedGroups.length > 0"
                    style="width: 100%; height: 60vh;"
                    class="ag-theme-alpine"
                    [columnDefs]="columnDefs"
                    [defaultColDef]="defaultColDef"
                    (cellClicked)="onSharedCellClicked($event)"
                    (gridReady)="onSharedGridReady($event)">
                </ag-grid-angular>
            </ng-container>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <div></div>
            <div class="d-flex align-items-center">
                <label class="me-2">Filas por página:</label>
                <select class="form-select form-select-sm me-2" style="width: auto;" (change)="onPageSizeChanged($any($event.target).value)">
                    <option *ngFor="let s of pageSizeOptions" [value]="s" [selected]="s === pageSize">{{s}}</option>
                </select>
                <button class="btn btn-outline-secondary btn-sm me-2 btn-page" (click)="prevPage()" [disabled]="currentPage <= 1">
                    <i class="ti ti-chevron-left"></i>
                </button>
                <span class="me-2">Página {{currentPage}}</span>
                <button class="btn btn-outline-secondary btn-sm btn-page" (click)="nextPage()" [disabled]="!hasNextPage">
                    <i class="ti ti-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="modalEvidence" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-centered1 modal-simple modal-add-new-cc">
        <div class="modal-content p-3 p-md-5">
            <div class="modal-body">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div class="text-center mb-4">
                    <h3 class="mb-2">Adjuntar evidencias</h3>
                </div>

                <ngx-dropzone (change)="onSelect($event)">
                    <ngx-dropzone-label>Seleccione las evidencias</ngx-dropzone-label>

                    <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                        [removable]="true" (removed)="onRemove(f)">
                        <ngx-dropzone-label></ngx-dropzone-label>
                    </ngx-dropzone-image-preview>
                </ngx-dropzone>

                <div class="text-center mt-4">
                    <button class="btn btn-primary" [disabled]="!files.length" (click)="uploadEvidences()">Cargar
                        evidencias</button>
                    <!-- <p class="text-muted">Diligencie los siguentes datos</p> -->
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="modalEvidenceShow" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-centered1 modal-simple modal-add-new-cc">
        <div class="modal-content p-3 p-md-5">
            <div class="modal-body">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div class="text-center mb-4">
                    <h3 class="mb-2">Evidencias de {{text_type}}</h3>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-12 mb-4 mb-lg-0" *ngFor="let item of evidences">
                        <img src="{{url_page}}{{item.img}}" class="w-100 shadow-1-strong rounded mb-4"
                            alt="Evidencias de carga tmh logistica" />
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="modalLogs" tabindex="1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-simple modal-refer-and-earn">
        <div class="modal-content p-3 p-md-5">
            <div class="modal-body">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div class="text-center mb-4">
                    <h3 class="mb-2">Histórico de actualizaciones</h3>
                </div>

                <div class="row" *ngFor="let item of logs; let i = index">
                    <div class="col-lg-6 mb-3">
                        <p class="mb-0 text-primary font-weight-bold">Ultima actualización:</p>
                        <ul class="mb-0">
                            <li>
                                <b class="text-dark">Fecha y hora: </b><span class="text-dark">{{item.created_at |
                                    date:'dd/MM/yyyy, HH:mm'}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-6 mb-3">
                        <p class="mb-0 text-primary font-weight-bold">Realizado por:</p>
                        <ul class="mb-0">
                            <li><span class="text-dark">{{item.name}}</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalObservation" tabindex="1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-simple modal-refer-and-earn">
        <div class="modal-content p-3 p-md-5">
            <div class="modal-body">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div class="text-center mb-4">
                    <h3 class="mb-2">Agregar Nota</h3>
                </div>
                <div class="input-group input-group-merge">
                    <textarea name="observation" class="form-control" cols="30" rows="10"
                        [(ngModel)]="service_notes"></textarea>
                </div>

                <div class="text-center mt-4">
                    <button class="btn btn-primary" (click)="addNoteApp()">Guardar</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalChangedUnit" tabindex="1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-simple modal-refer-and-earn">
        <div class="modal-content p-3 p-md-5">
            <div class="modal-body">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalStatus" tabindex="1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-sm modal-simple modal-refer-and-earn">
        <div class="modal-content p-1 p-md-1">
            <div class="modal-header">
                <h4 class="modal-title text-center w-100">Actualizar estado</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

                <div class="text-center mb-4">
                    <h6 class="mb-2">Selecciona el estado que deseas actualizar</h6>
                </div>

                <div class="row">
                    <div class="col-lg-6 d-grid gap-1 mb-1" *ngFor="let item of dataCombo">
                        <input type="radio" class="btn-check" name="status_option" id="btn-check-{{item.id}}" [value]="item.id"
                            autocomplete="off">
                        <label class="btn btn-sm fw-semibold" [ngStyle]="{
                                'background-color': item.bg || '#e0e0e0',
                                'color': item.color || '#333'
                            }"
                            for="btn-check-{{item.id}}">{{item.name}}</label>
                    </div>
                </div>
                <div class="row" *ngIf="canDo('Servicios Unificados', 'Reportar falla')">
                    <div class="col">
                        <p class="mb-0 mt-4">¿La unidad en servicio presenta falla?</p>
                        <a role="button" class="upload_file" (click)="routerLink({id: dataSelect.unit_id, unit: dataSelect.unit, plates: dataSelect.plates})">Reportar falla</a>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-block m-0 p-0">
                <div class="row m-0 p-0">
                    <div class="col-lg-6 m-0">
                        <button type="button" class="btn btn-outline-primary m-1 w-100" data-bs-dismiss="modal"
                            aria-label="Close">Cancelar</button>
                    </div>
                    <div class="col-lg-6 m-0">
                        <button type="button" class="btn btn-primary m-1 w-100" (click)="changedStatus()">Actualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalEvidenceOption" tabindex="1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-sm modal-simple modal-refer-and-earn">
        <div class="modal-content p-1 p-md-1">
            <div class="modal-body">
                <button type="button" class="btn-close" data-bs-dismiss="modal" style="top: 0; right: 0;"
                    aria-label="Close"></button>
                <div class="text-center mb-4">
                    <h4 class="mb-2">Seleccione una opción</h4>
                </div>

                <div class="d-grid gap-1 col-lg-12 mx-auto">
                    <button *ngIf="(status_id == 3 && !evidence_1  ) && dataUser.type_admin != 4 "
                        (click)="modalActiveEvidence(service_id, status_id)" type="button"
                        class="btn mb-1 btn-outline-info btn-lg waves-effect waves-light rounded-pill">Subir
                        evidencias</button>
                    <button *ngIf="evidence_1" (click)="modalOpenEvidence(service_id, 3)" type="button"
                        class="btn mb-1 btn-outline-info btn-lg waves-effect waves-light rounded-pill">Evidencias de
                        Carga</button>
                    <button *ngIf="(status_id == 4 && !evidence_2 ) && dataUser.type_admin != 4"
                        (click)="modalActiveEvidence(service_id, status_id)" type="button"
                        class="btn mb-1 btn-outline-info btn-lg waves-effect waves-light rounded-pill">Subir Evidencias
                        de Descarga</button>
                    <button *ngIf="evidence_2" (click)="modalOpenEvidence(service_id, 4)" type="button"
                        class="btn mb-1 btn-outline-info btn-lg waves-effect waves-light rounded-pill">Evidencias de
                        Descarga</button>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">{{text_loading}}</p>
</ngx-spinner>

